import { PlacementSize } from "@order/models/placement-size";

export class SizeViewModel {
	readonly label: string;

	readonly widthRatio: number;
	readonly depthRatio: number;

	isSelected: boolean = false;
	isValid: boolean = true;

	constructor (placementSize: PlacementSize) {
		this.label = placementSize.label || "";

		this.widthRatio = placementSize.pageWidthFraction ?? 1;
		// if (placementSize.pageColumns && placementSize.columns) {
		// 	this.widthRatio = placementSize.columns / placementSize.pageColumns;
		// }

		this.depthRatio = placementSize.pageHeightFraction ?? 1;
		// if (placementSize.pageHeight && placementSize.height) {
		// 	this.depthRatio = placementSize.height / placementSize.pageHeight;
		// }
	}
}
